module.exports = __webpack_public_path__ + "static/media/yellow_2.73881851.jpg";